import service from '@/utils/request'; // CreateStationOilTankInfo 创建油罐基础信息
// @Tags Station
// @Summary 创建油罐基础信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationOilTankModel true "创建油罐基础信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/oilTankInfo/create [post]

export var createStationOilTankInfo = function createStationOilTankInfo(data) {
  return service({
    url: '/stationManage/oilTankInfo/create',
    method: 'post',
    data: data
  });
}; // DeleteStationOilTankInfo 删除油罐信息
// @Tags Station
// @Summary 删除油罐信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationOilTankModel true "删除油罐信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /stationManage/oilTankInfo/delete [delete]

export var deleteStationOilTankInfo = function deleteStationOilTankInfo(data) {
  return service({
    url: '/stationManage/oilTankInfo/delete',
    method: 'post',
    data: data
  });
}; // DeleteStationOilTankInfoByIds 批量删除油罐信息
// @Tags Station
// @Summary 批量删除油罐信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "批量删除油罐信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"批量删除成功"}"
// @Router /stationManage/oilTankInfo/deleteByIds [delete]

export var deleteStationOilTankInfoByIds = function deleteStationOilTankInfoByIds(data) {
  return service({
    url: '/stationManage/oilTankInfo/deleteByIds',
    method: 'post',
    data: data
  });
}; // UpdateStationOilTankInfo 更新油罐基础信息
// @Tags Station
// @Summary 更新油罐基础信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationOilTankModel true "更新油罐基础信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /stationManage/oilTankInfo/update [put]

export var updateStationOilTankInfo = function updateStationOilTankInfo(data) {
  return service({
    url: '/stationManage/oilTankInfo/update',
    method: 'put',
    data: data
  });
}; // UpdateStationOilTankInfo 更新油罐预警信息
// @Tags Station
// @Summary 更新油罐预警信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationOilTankModel true "更新油罐预警信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /stationManage/oilTankInfo/updateAlerm [put]

export var updateAlermStationOilTankInfo = function updateAlermStationOilTankInfo(data) {
  return service({
    url: '/stationManage/oilTankInfo/updateAlerm',
    method: 'put',
    data: data
  });
}; // FindStationOilTankInfo 根据id查询油罐基础信息
// @Tags Station
// @Summary 根据id查询油罐基础信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunModel.StationOilTankModel true "根据id查询油罐基础信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /stationManage/oilTankInfo/find [get]

export var findStationOilTankInfo = function findStationOilTankInfo(params) {
  return service({
    url: '/stationManage/oilTankInfo/find',
    method: 'get',
    params: params
  });
}; // GetStationOilTankInfoList 分页获取油罐列表信息
// @Tags Station
// @Summary 分页获取油罐列表信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.StationOilTankInfoSearch true "分页获取油罐列表信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationManage/oilTankInfo/getList [get]

export var getStationOilTankInfoList = function getStationOilTankInfoList(params) {
  return service({
    url: '/stationManage/oilTankInfo/getList',
    method: 'get',
    params: params
  });
}; // getOilManageTankinList 分页获取卸油入罐列表
// @Tags Station
// @Summary 分页获取卸油入罐列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.StationOilTankInfoSearch true "分页获取卸油入罐列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /oilManage/tankin/getList [get]

export var getOilManageTankinList = function getOilManageTankinList(params) {
  return service({
    url: '/oilManage/tankin/getList',
    method: 'get',
    params: params
  });
}; // postOilManageTankinCreate 创建入罐油罐信息
// @Tags Station
// @Summary 创建入罐油罐信息
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "创建入罐油罐信息"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"创建成功"}"
// @Router /oilManage/tankin/create [delete]

export var postOilManageTankinCreate = function postOilManageTankinCreate(data) {
  return service({
    url: '/oilManage/tankin/create',
    method: 'post',
    data: data
  });
}; // postOilManageTankinCreate 卸油状态更新
// @Tags Station
// @Summary 卸油状态更新
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "卸油状态更新"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /oilManage/tankin/create [delete]

export var postOilManageTankinOpenEnd = function postOilManageTankinOpenEnd(data) {
  return service({
    url: '/oilManage/tankin/open/end',
    method: 'post',
    data: data
  });
};